/**
 * Created by Ning Jiang on 1/30/2020.
 */

require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomBounce.js");
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TweenLite} from "gsap";
import {DWBackground} from "../../background/DWBackground";
import {FireParticles} from "../../particles/FireParticles";

export class DeadwoodScatterAttentionView extends BaseView {

    private _bounceTween:TweenLite;
    private _currentOrientation:Orientation;

    constructor() {
        super();

        CustomBounce.create("attentionBounce", {strength : 0.4, squash : 0, endAtStart : true, squashID : "scatter"});
        CustomBounce.create("winBounce", {strength : 0.8, squash : 0, endAtStart : true, squashID : "scatter"});
    }

    public playAttentionBounce():void {
        this.resetBounceTween();
        this._bounceTween = TweenLite.to(StageManager.stage, 0.1, {y : "+=" + 20, ease : "attentionBounce"});
    }

    public playWinAttentionBounce():void {
        this.resetBounceTween();
        this._bounceTween = TweenLite.to(StageManager.stage, 0.2, {y : "+=" + 30, ease : "winBounce"});
        EventHandler.dispatchEvent(new GameEvent(DWBackground.FS_FIRE, true, true));
        EventHandler.dispatchEvent(new GameEvent(FireParticles.START));
    }

    private resetBounceTween():void {
        if(this._bounceTween && this._bounceTween.isActive()) {
            this._bounceTween.progress(1);
            if(StageManager.legacyScaling) {
                StageManager.stage.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
            }
        }
    }

    protected onResize(resizeData:IResizeData):void {
        if(this._currentOrientation === resizeData.orientation) {
            return;
        }

        this._currentOrientation = resizeData.orientation;
        this.resetBounceTween();
    }
}